import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import ImageBackground from '../common/imageBackground';
import FeedbackList from './FeedbackList';
import FeedbackQuestion from './FeedbackQuestion';
import './styles.css';

class Service1210 extends Component {
  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1210">
        <ImageBackground id="background" />
        <Switch>
        <Route
            path="/feedback/list/submit/defaultAdmission"
            render={routeProps => <FeedbackList {...routeProps} submitted='admission' />}
          />
        <Route
            path="/feedback/list/submit/DefaultRating"
            render={routeProps => <FeedbackList {...routeProps} submitted='rating' />}
          />
        <Route
            path="/feedback/list/submit/orthoPatientAdmission"
            render={routeProps => <FeedbackList {...routeProps} submitted='admission' />}
          />
        <Route
            path="/feedback/list/submit/orthoPatientRating"
            render={routeProps => <FeedbackList {...routeProps} submitted='rating' />}
          />
        <Route
            path="/feedback/list/submit/chfPatientAdmission"
            render={routeProps => <FeedbackList {...routeProps} submitted='admission' />}
          />
        <Route
            path="/feedback/list/submit/chfPatientRating"
            render={routeProps => <FeedbackList {...routeProps} submitted='rating' />}
          />
          <Route path="/feedback/list" component={FeedbackList} />
          <Route path="/feedback/question/:survey/:question/:popup" component={FeedbackQuestion} />
          <Route path="/feedback/question/:survey/:question" component={FeedbackQuestion} />
          <Route
            path="/feedback/question/:survey"
            render={({ match }) => <Redirect to={`/feedback/question/${match.params.survey}/1`} />}
          />
          <Route path="/feedback" render={() => <Redirect to="/feedback/list" />} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Service1210);
